import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/meetup1.jpeg'
import _imports_1 from '../assets/meetup2.jpeg'
import _imports_2 from '../assets/meetup3.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-e15f1fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photos" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Photos", -1))
const _hoisted_3 = { class: "row justify-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "October 2022", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Bitcoiners posing for a picture.",
  src: _imports_0,
  class: "center-fit"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Bitcoiners posing for a picture.",
  src: _imports_1,
  class: "center-fit"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Bitcoiners posing for a picture.",
  src: _imports_2,
  class: "center-fit"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showHideOctober2022 && _ctx.showHideOctober2022(...args)))
      }, _toDisplayString(_ctx.october2022label), 1)
    ]),
    (_ctx.october2022)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showHideOctober2022 && _ctx.showHideOctober2022(...args)))
            }, _toDisplayString(_ctx.october2022label), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}